<div *ngIf="!isLoggedinUser">
  <div class="row">
    <div class="col-3 pd-10">
      <div class="vs-checkbox" *ngIf="rfqTypes !== undefined">
        <input
          id="endUserAddress"
          type="checkbox"
          [checked]="orderType === OrderType.STOCK"
          [disabled]="orderType === OrderType.STOCK"
          value="true"
          [(ngModel)]="isCopySoldToAddressData"
          (change)="onCopyAddress(); resetAddress()"
        />
        <label for="endUserAddress"> {{ "quoteCheckout.endUserAddress" | cxTranslate }}  </label>
      </div>
    </div>
  </div>
  <div [formGroup]="endCustomerAddress">
    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserName" | cxTranslate }}</label>

          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserName" | cxTranslate }}'
            formControlName="endUserName"
            [ngClass]="isSubmittedCopy && !endUserName.valid ? 'error' : ''"
          [attr.maxlength]="maxVal"
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="isSubmittedCopy && !endUserName.valid"
          >
          {{ "quoteCheckout.endUserName2" | cxTranslate }} 
          </label>
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserAddressL1" | cxTranslate }} </label>
          <input
            type="text"
            formControlName="line1"
            placeholder='{{ "quoteCheckout.endUserAddressL1" | cxTranslate }}'
            maxlength="35"
            [ngClass]="
              isSubmitted && (!line1.valid || !line1.value) ? 'error' : ''
            "
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="isSubmitted && !line1.valid"
          >
          {{ "quoteCheckout.endUserAddressL11" | cxTranslate }} 
          </label>
        </div>
      </div>

      <div class="col-3">
        <div class="vs-text-field">
          <label>{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}'
            formControlName="line2"
            maxlength="35"
          />
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div>
          <label
            ><span class="require red-color">* </span
            ><span class="label-custom">{{ "quoteCheckout.endUserCountry" | cxTranslate }}</span></label
          >
          <ng-select
            #countryFocus
            [searchable]="true"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            [ngClass]="
              (isSubmitted && country.invalid) ||
              (isSubmitted && country.value == 'Select')
                ? 'error-select'
                : ''
            "
            formControlName="country"
            (change)="saveCountryData()"
          >
            <ng-option
              *ngFor="let country of countryNames"
              [value]="country.isocode"
              >{{ country.name }}</ng-option
            >
          </ng-select>
          <label
            class="error"
            *ngIf="
              (isSubmitted && country.invalid) ||
              (isSubmitted && country.value == 'Select')
            "
          >
          {{ "quoteCheckout.endUserCountry2" | cxTranslate }} 
          </label>
        </div>
      </div>

      <div class="col-3">
        <div>
          <label
            ><span class="require red-color" *ngIf="countryRegionNames?.length>0">* </span
            ><span class="label-custom">{{ "quoteCheckout.endUserState" | cxTranslate }}</span></label
          >
          <ng-select
            #stateFocus
            [searchable]="true"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            formControlName="state"
            [ngClass]="
              (isSubmitted && state.invalid) ||
              (isSubmitted && state.value == 'Select')
                ? 'error-select'
                : ''
            "
            (change)="selectState()"
          >
            <ng-option
              *ngFor="let region of countryRegionNames"
              [value]="region.isocode"
              >{{ region.name }}</ng-option
            >
          </ng-select>

          <label
            class="error"
            *ngIf="
              (isSubmitted && state.invalid) ||
              (isSubmitted && state.value == 'Select')
            "
          >
            {{ "quoteCheckout.endUserState2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserCity" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserCity" | cxTranslate }}'
            [ngClass]="isSubmitted && !city.valid ? 'error' : ''"
            formControlName="city"
            maxlength="35"
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="isSubmitted && !city.valid"
          >
            {{ "quoteCheckout.endUserCity2" | cxTranslate }}
          </label>
        </div>
      </div>
      <div class="col-3">
        <div class="vs-text-field">
          <label><span class="require" *ngIf="country.value != 'CN'">* </span>{{ "quoteCheckout.endUserZip" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserZip" | cxTranslate }}'
            maxlength="10"
            [ngClass]="
              (postalCode.invalid &&
                (postalCode.dirty || postalCode.touched) &&
                !postalCode.valid) ||
              (isSubmitted && !postalCode.valid)
                ? 'error'
                : ''
            "
            formControlName="postalCode"
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="
              (postalCode.invalid &&
                (postalCode.dirty || postalCode.touched) &&
                !postalCode.valid) ||
              (isSubmitted && !postalCode.valid)
            "
          >
            {{ "quoteCheckout.endUserZip2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserIndustry" | cxTranslate }}</label>
          <ng-select
            #endUserIndustryFocus
            [searchable]="false"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            [ngClass]="
              (isSubmittedCopy && !endUserIndustry.valid) ||
              (isSubmittedCopy && endUserIndustry.value == 'Select')
                ? 'error-select'
                : ''
            "
            formControlName="endUserIndustry"
            (change)="selectEndUserIndustry()"
          >
            <ng-option
              *ngFor="let industry of endUserIndustries"
              [value]="industry.code"
              >{{ industry.value }}</ng-option
            >
          </ng-select>
          <label
            class="error"
            *ngIf="
              (isSubmittedCopy && !endUserIndustry.valid) ||
              (isSubmittedCopy && endUserIndustry.value == 'Select')
            "
          >
            {{ "quoteCheckout.endUserIndustry2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div>
          <label>
            <span class="require">* </span>{{ "quoteCheckout.selectRegion" | cxTranslate }}
          </label>
          <ng-select
            #legalEntityFocus
            [searchable]="false"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            formControlName="endUserRegion"
            [ngClass]="
              isSubmittedCopy &&
              (endUserRegion.value == 'Select' || endUserRegion.invalid)
                ? 'error-select'
                : ''
            "
            (change)="getEntity($event)"
          >
            <ng-option
              *ngFor="let entity of legalEntityData"
              [value]="entity.code"
              >{{ entity.value }}</ng-option
            >
          </ng-select>
          <label
            class="error"
            *ngIf="
              isSubmittedCopy &&
              (endUserRegion.value == 'Select' || endUserRegion.invalid)
            "
          >
          {{ "quoteCheckout.selectRegion2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoggedinUser">
  <div class="enduserContainer">
    <div class="shiping-details">
      <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-4">
          <div class="section-container">
            {{ "quoteCheckout.endCustomerAddress" | cxTranslate }}
            <span
              class="selected"
              *ngIf="rfqTypes !== undefined && orderType !== rfqTypes[1]?.code"
            >
              <span
                *ngIf="selectedAddress?.country || selectedAddress?.firstName"
                class="sel"
                >{{ "quoteCheckout.selected" | cxTranslate }}
              </span>
            </span>
          </div>
          <label
            *ngIf="
              !(selectedAddress?.country || selectedAddress?.firstName) &&
              isSubmitted
            "
            class="error"
            >{{ "quoteCheckout.selectAddress" | cxTranslate }}
          </label>
          <address
            [ngClass]="this.quoteCartType == QuoteStatus.EDIT ? 'disabled' : ''"
          >
            <div>
              {{ selectedAddress?.firstName }} {{ selectedAddress?.lastName }}
            </div>
            <div>
              {{ selectedAddress?.companyName
              }}{{ selectedAddress?.companyName ? "," : "" }}
            </div>
            <div>
              {{ selectedAddress?.line1
              }}{{ selectedAddress?.line1 ? "," : "" }}
              {{ selectedAddress?.line2
              }}{{ selectedAddress?.line2 ? "," : "" }}
            </div>
            <div>
              {{ selectedAddress?.town }}{{ selectedAddress?.town ? "," : "" }}
            </div>
            <div>
              {{ selectedAddress?.region?.name
              }}{{ selectedAddress?.region?.name ? "," : "" }}
            </div>
            <div>
              {{ selectedAddress?.country?.name
              }}{{ selectedAddress?.country?.name ? "," : "" }}
            </div>
            <div>{{ selectedAddress?.postalCode }}</div>
          </address>

          <div class="ter-btn-holder" *ngIf="orderType !== OrderType.STOCK">
            <button
              class="vs-tertiary-btn"
              (click)="selectAddress()"
              [disabled]="this.quoteCartType == QuoteStatus.EDIT"
            >
              <span
                *ngIf="selectedAddress?.country || selectedAddress?.firstName"
              >
                {{ "quoteCheckout.selectAnotherAddress" | cxTranslate }}
              </span>
              <span *ngIf="!selectedAddress">{{ "quoteCheckout.selectAddress2" | cxTranslate }}</span>
            </button>
          </div>
          <div class="mt-22" [formGroup]="endCustomerAddress">
            <div class="endUserLable">
              <div class="enduserdropdown">
                <label><span class="require">* </span>{{ "quoteCheckout.endUserIndustry" | cxTranslate }}</label>
                <ng-select
                  #endUserIndustryFocus
                  [searchable]="false"
                  [clearable]="false"
                  appendTo="body"
                  placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
                  formControlName="endUserIndustry"
                  [ngClass]="
                    ((isSubmitted && !endUserIndustry.valid) ||
                      (isSubmitted && endUserIndustry.value === 'Select')) &&
                    this.quoteCartType != QuoteStatus.EDIT
                      ? 'error-select'
                      : ''
                  "
                  (change)="selectEndUserIndustry()"
                >
                  <ng-option
                    *ngFor="let industry of endUserIndustries"
                    [value]="industry.code"
                    >{{ industry.value }}</ng-option
                  >
                </ng-select>
                <label
                  class="error"
                  *ngIf="
                    ((isSubmitted && !endUserIndustry.valid) ||
                      (isSubmitted && endUserIndustry.value === 'Select')) &&
                    this.quoteCartType != QuoteStatus.EDIT
                  "
                >
                  {{ "quoteCheckout.endUserIndustry2" | cxTranslate }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-sm-8 fl_right">
          <vs-address
            *ngIf="isSelectAddress"
            [componentAddress]="componentAddress"
            (reciveEndUserAddress)="selectedAdd($event)"
            (closeEndAdd)="closeForm($event)"
            [cartName]="cartName"
          ></vs-address>
        </div>
      </div>
    </div>
  </div>
</div>
